import React, { useEffect } from 'react';
import Header from '../components/layout/Header';
import Hero from '../components/home/Hero';
import Categories from '../components/home/Categories';
import Presentation from '../components/home/Presentation';
import Stats from '../components/home/Stats';
import FAQ from '../components/home/FAQ';
import Footer from '../components/layout/Footer';
import './Home.css';
import apple from '../assets/apple.png';
import { useLanguage } from '../context/LanguageContext';

function Home() {
  const { t } = useLanguage();
  
  // Assurer que la page s'affiche tout en haut au chargement
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="home-page">
      <Header />
      <main className="main-content">
        <Hero />
        <Categories />
        <Presentation />
        <Stats />
        <FAQ />
      </main>
      <Footer />
      
      <div className="fixed-download-buttons">
        <button className="fixed-download-btn">
          <img src={apple} alt="Apple" className="fixed-btn-icon" />
          <span>{t('appstore')}</span>
        </button>
      </div>
    </div>
  );
}

export default Home; 